import { formatToTitleCase } from './format-to-title-case';

type Professional = {
  honorific: string;
  name: string;
};

export const professionalDisplayName = (professional: Professional) => {
  if (!professional.honorific) {
    return formatToTitleCase(professional.name);
  }

  return formatToTitleCase(`${professional.honorific} ${professional.name}`);
};
